export const environment = {
   production: false,
   ibtVendorServiceUrl: "https://sbibtsrv.certiport.com/",
   appInsightsConnString: "InstrumentationKey=13bc4492-6f67-495c-95ce-a74ee556e804;IngestionEndpoint=https://centralus-0.in.applicationinsights.azure.com/",
   appInsightsInstrumentationKey: "13bc4492-6f67-495c-95ce-a74ee556e804"
};
